module.exports = __webpack_public_path__ + "img/rtc2.d7a1b827.svg";